import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import { useMutationCreateAccount } from "../query/users/mutations";
import { AccountIntendedUse } from "../services/users";
import { useWSPlaidLink } from "./usePlaidLink";

type Config = {
  onSuccess: (accounts: IAccount[]) => void;
  intendedUse?: AccountIntendedUse;
};

export const useWSPlaidLinkExtended = (config: Config) => {
  const [createAccount] = useMutationCreateAccount();
  const { openSnackbar } = useWSSnackbar();

  return useWSPlaidLink({
    intendedUse: config.intendedUse,
    onSuccess: async (publicToken: string) => {
      openSnackbar({
        message: "Linking accounts",
        icon: {
          name: "loader"
        }
      });

      const createResponse = await createAccount({
        publicToken,
        intendedUse: config.intendedUse,
        status: AccountStatus.Pending
      });

      const createdAccounts = createResponse
        ? Array.isArray(createResponse)
          ? createResponse
          : [createResponse]
        : [];

      config.onSuccess(createdAccounts);
    }
  });
};
